module.exports = __webpack_public_path__ + "static/banner-mob-1a1671eb908468487af3a46a9e0a0f16.mp4";